const MAX_DISPLAY_NAME_LENGTH = 120;

export function normalizeSafeLabel(
  value: unknown,
  maxLength = MAX_DISPLAY_NAME_LENGTH
): string | null {
  if (typeof value !== "string") {
    return null;
  }

  const normalized = value
    .normalize("NFKC")
    .replace(/[\u0000-\u001f\u007f]+/g, "")
    .replace(/[^\p{L}\p{M}\p{N} .,'_-]+/gu, "")
    .replace(/\s+/g, " ")
    .trim()
    .slice(0, maxLength)
    .trim();

  return normalized || null;
}

export function normalizeDisplayName(value: unknown): string | null {
  return normalizeSafeLabel(value, MAX_DISPLAY_NAME_LENGTH);
}
